
<script setup lang="ts">
import { computed } from '@vue/reactivity';

type ButtonType = 'default' | 'primary';
type ButtonSize = 'xs' | 'm' | 'l';

interface Props {
  type?: ButtonType;
  size?: ButtonSize;
  width?: string | number;
  disabled?: boolean;
  loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  type: 'default',
  size: 'm',
  width: 'auto',
  disabled: false,
  loading: false,
});

const width = computed(() => (typeof props.width === 'number' ? `${props.width}px` : props.width));

</script>

<template>
  <button
    class="ui-kk-button"
    :class="[`size-${props.size}`, `type-${props.type}`, {disabled: props.disabled, loading: props.loading}]"
    :disabled="props.disabled"
    :style="{width: width}"
  >
    <span v-if="loading">
      <!-- 待支持loading -->
      ...
    </span>
    <span
      v-else
      class="ui-kk-button__inner"
    >
      <slot />
    </span>
  </button>
</template>


<style lang="scss">
@import '@/style/variable.scss';

// 尺寸变量
$size-xs-height: 28px;
$size-m-height: 44px;
$size-l-height: 52px;
$pixel-width: 6px;
$pixel-width-xs: 4px;

.ui-kk-button {
  position: relative;
  background-clip: content-box;
  box-sizing: border-box;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0 $pixel-width;
  text-align: center;
  font-weight: 500;

  &::before {
    left: 0;
    right: 0;
    top: $pixel-width;
    bottom: $pixel-width;
    content: '';
    display: block;
    position: absolute;
    background-color: inherit;
  }

  // 类型
  &.type-default {
    background-color: #F6F8FA;
    color: #242526;
  }
  &.type-primary {
    background-color: #3FFF88;
    color: #242526;
  }
  &.type-black {
    background-color: #000;
    color: #242526;
  }


  // 尺寸
  &.size-xs {
    height: $size-xs-height;
    font-size: 12px;
    padding: 0 $pixel-width-xs;
    &::before {
      top: $pixel-width-xs;
      bottom: $pixel-width-xs;
    }
  }
  &.size-m {
    height: $size-m-height;
    font-size: 14px;
  }
  &.size-l {
    height: $size-l-height;
    font-size: 16px;
  }

  // 状态
  &.disabled {
    color: #CAD2E5;
    background-color: #F6F8FA;
    cursor: unset;
  }


  &__inner {
    position: relative;
    z-index: 1;
    display: inline-block;
    white-space: nowrap;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}
</style>
